import React from 'react';
import NegotiationCenter from '../../components/negotiation/NegotiationCenter';

// Le layout (sidebar + header + main paddé) est fourni par <AdminLayout> dans App.js.
const NegotiationsPage = () => <NegotiationCenter />;

export default NegotiationsPage;
